import { createAction } from '@reduxjs/toolkit'
import { makeCommunicationActionCreator } from 'shared/utils/communication/actions/makeCommunicationActionCreator'

export const getSportToken = makeCommunicationActionCreator({
  loading: '@altenar/GET_SPORT_TOKEN_LOADING',
  success: '@altenar/GET_SPORT_TOKEN_SUCCESS',
  error: '@altenar/GET_SPORT_TOKEN_ERROR',
  reset: '@altenar/GET_SPORT_TOKEN_RESET',
})<undefined, string>(
  async ({
    deps: {
      extra: { api },
    },
  }) => {
    const response = await api.altenar.getToken()
    return response.data
  },
)

export const clearSportToken = createAction('@altenar/CLEAR_SPORT_TOKEN')
